import { toast } from "sonner";

export type CartAddOutcome =
  | { kind: "error" | "busy"; added: 0 }
  | { kind: "added"; added: number }
  | { kind: "adjusted"; added: number; max: number }
  | { kind: "full"; added: 0 }
  | { kind: "soldout"; added: 0 };

/** Quanto realmente entra no carrinho, respeitando estoque online e o que já está na linha. */
export function planCartAdd(already: number, requested: number, maxStock?: number): CartAddOutcome {
  const want = Math.max(0, Math.floor(requested));
  if (maxStock === undefined) return { kind: "added", added: want };
  if (maxStock <= 0) return { kind: "soldout", added: 0 };
  const room = maxStock - already;
  if (room <= 0) return { kind: "full", added: 0 };
  if (want > room) return { kind: "adjusted", added: room, max: maxStock };
  return { kind: "added", added: want };
}

export const CART_ADDED_TOAST_ID = "cart-added";

/** Aviso único do site após adicionar: não abre o carrinho sozinho; a ação abre. */
/**
 * Modais com foco preso (player, janela do produto) registram um aviso LOCAL dentro do próprio
 * focus scope: o aviso global ficaria fora do alcance do Tab. Só o host mais recente recebe.
 */
type NoticeHost = (n: { description?: string; openCart: () => void }) => void;
const hosts: NoticeHost[] = [];
export function registerCartNoticeHost(host: NoticeHost): () => void {
  hosts.push(host);
  return () => { const i = hosts.lastIndexOf(host); if (i >= 0) hosts.splice(i, 1); };
}

export function showCartAddedNotice(openCart: () => void, description?: string) {
  const host = hosts[hosts.length - 1];
  if (host) { toast.dismiss(CART_ADDED_TOAST_ID); host({ description, openCart }); return; }
  const mobile = typeof window !== "undefined" && typeof window.matchMedia === "function"
    && window.matchMedia("(max-width: 767px)").matches;
  toast.success("Produto adicionado ao carrinho", {
    id: CART_ADDED_TOAST_ID,
    description,
    duration: 4000,
    position: mobile ? "top-center" : "bottom-center",
    action: { label: "Abrir carrinho", onClick: openCart },
  });
}

export function showCartAddError(title: string, description?: string) {
  toast.error(title, { id: CART_ADDED_TOAST_ID, description, duration: 4000 });
}

/** Clique/foco no aviso não deve fechar o player ou o popup do produto que estão abertos. */
export function isCartNoticeTarget(target: EventTarget | null): boolean {
  return !!(target as Element | null)?.closest?.("[data-sonner-toaster]");
}
